import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

type ChartSaveDialogProps = {
	isOpen: boolean;
	toggle: () => void;
	createChart: (value: "duplicate" | "new") => void;
};

const ChartCreateDialog = ({ isOpen, toggle, createChart }: ChartSaveDialogProps) => {
	return (
		<Transition appear show={isOpen} as={Fragment}>
			<Dialog open={isOpen} onClose={() => toggle()} className="relative z-80">
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black/30" aria-hidden="true" />
				</Transition.Child>
				<div className="fixed inset-0 flex items-center justify-center p-4">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<Dialog.Panel className="max-w-sm p-8 mx-auto bg-white rounded w-96 h-96">
							<Dialog.Title className="text-2xl text-center uppercase text-primary-blue">
								Create New Chart
							</Dialog.Title>
							<p className="my-8 text-center">
								Would you like to create a new chart by duplicating this chart
								OR start from a blank chart?
							</p>
							<div className="flex justify-center my-4">
								<button
									className="uppercase w-full inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 hover:bg-primary-blue hover:text-white"
									onClick={() => createChart("duplicate")}
									type="button"
								>
									Duplicate This Chart
								</button>
							</div>
							<div className="flex justify-center">
								<button
									className="uppercase w-full inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 border border-primary-blue text-base font-semibold rounded-md shadow-sm text-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 hover:bg-primary-blue hover:text-white"
									onClick={() => createChart("new")}
									type="button"
								>
									Start from Blank chart
								</button>
							</div>
						</Dialog.Panel>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ChartCreateDialog;
